<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ProductBlock from '../parts/ProductBlock.vue';

const props = defineProps({
  source: { type: Object, required: true },
  platform: { type: String, default: '' },
});

const { t } = useI18n();
const dialog = computed(() => props.source.dialog || {});
const product = computed(() => props.source.product || {});
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-wrap items-center gap-2">
      <span
        v-if="dialog.subject"
        class="text-[13px] font-semibold text-n-slate-12"
      >
        {{ dialog.subject }}
      </span>
      <span
        v-if="dialog.order_id"
        class="inline-flex items-center gap-1 h-5 px-2 rounded-md bg-n-alpha-2 text-[11px] text-n-slate-11"
      >
        <span class="i-lucide-receipt size-3" />
        {{ t('MULTICHAT.SOURCE.ORDER') }}
        <span class="font-mono text-n-slate-12">{{ dialog.order_id }}</span>
      </span>
      <span
        v-if="dialog.order_status"
        class="inline-flex items-center gap-1 h-5 px-2 rounded-full bg-n-blue-3 text-n-blue-11 text-[11px] font-semibold"
      >
        <span class="i-lucide-truck size-3" />
        {{ dialog.order_status }}
      </span>
    </div>
    <ProductBlock v-if="product.name" :product="product" :platform="platform" />
  </div>
</template>
